import React from 'react';
import './styles/App.scss';
import { Routes, Route } from 'react-router-dom';
import BaseLayout from './containers/BaseLayout';
import Home from './containers/Home';
import RefineResults from './containers/RefineResults';

const App = () => {
  return (
    <Routes>
      <Route path='/' element={<BaseLayout />}>
        <Route index element={<Home />} />
        <Route path='refine-results' element={<RefineResults />} />
      </Route>
    </Routes>
  );
};

export default App;
